var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status),expression:"status"}],staticClass:"v-contextmenu",style:({
    left: _vm.style.left,
    top: _vm.style.top,
  }),on:{"contextmenu":function($event){$event.preventDefault();}}},[_c('ContextmenuContent',{attrs:{"menus":_vm.menus,"isDark":_vm.isDark,"subMenuPosition":_vm.style.subMenuPosition,"clickMenuItem":_vm.clickMenuItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }